import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { connect } from 'react-redux';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import { logging } from '../redux/logging';
import { jsx as _jsx } from "react/jsx-runtime";
export const withLogger = namespace => WrappedComponent => {
  if (typeof namespace !== 'string') {
    throw new Error('withLogger expects first parameter to be a string. ' + `(${typeof namespace} given)\n` + "Usage withLogger('namespace')(YourComponent)");
  }
  function WithLogger(props) {
    const enhancedProps = {
      ...props,
      logger: logging(props.dispatch, namespace)
    };
    return /*#__PURE__*/_jsx(WrappedComponent, {
      ...enhancedProps
    });
  }
  WithLogger.displayName = `WithLogger(${getDisplayName(WrappedComponent)})`;
  WithLogger.WrappedComponent = WrappedComponent;
  const HoistedComponent = hoistNonReactStatic(WithLogger, WrappedComponent);
  HoistedComponent.preFetch = function preFetch(props) {
    const loggerProps = {
      logger: logging(props.dispatch, namespace)
    };
    const wrappedPreFetch = getDataDependency(WrappedComponent, 'preFetch');
    if (wrappedPreFetch) {
      return wrappedPreFetch({
        ...props,
        ...loggerProps
      });
    }
    return null;
  };
  return connect()(WithLogger);
};